<template>
  <div>
    <div v-if="!isLoadingData && pageData"  class="section__shared">
      <section class="section__shared-links" >
        <app-link-section v-if="isLoadingData || !pageCommonData"></app-link-section>
        <template v-else-if="pageCommonData.show_related_link">
          <app-link-section
          :linkIds="pageCommonData.configuration_des_liens_utiles.link_list"></app-link-section>
        </template>
      </section>

    <section class="section__shared-actus" >
        <app-related-news v-if="isLoadingData || !pageCommonData"
          title="Dernières actus"
        ></app-related-news>
        <template v-else-if="pageCommonData.show_actus">
          <app-related-news
          :title="'Dernières actus '+pageCommonData.fil_actus_conf.set_custom_title"
          :linkName="pageData.acf.actus_group.link_actus"
          :nbActus="parseInt(pageData.acf.actus_group.nb_items)"
          :categories="pageCommonData.fil_actus_conf.filter_categories"
          ></app-related-news>
        </template>
      </section>

      <section class="section__shared-shop">
        <app-shop-section v-if="isLoadingData || !pageCommonData"></app-shop-section>
        <template v-else-if="pageCommonData.show_shop_area">
          <app-shop-section
          :title="pageData.acf.boutique_group.titre"
          :subtitle="pageData.acf.boutique_group.sous_titre"
          :linkName="pageData.acf.boutique_group.lien_boutique"
          >
          </app-shop-section>
        </template>
      </section>

      <section class="section__shared-partners">
        <app-partners-section v-if="isLoadingData || !pageCommonData"></app-partners-section>
        <template v-else-if="pageCommonData.show_sponsors">
          <app-partners-section
          :title="pageData.acf.sponsors_group.titre"
          :subtitle="pageData.acf.sponsors_group.sous_titre"
          :linkPartners="pageData.acf.sponsors_group.lien_all_sponsors"
          :linkBecomePartner="pageData.acf.sponsors_group.lien_become_sponsors"
          :partnersIds="pageData.acf.sponsors_group.sponsors_list"></app-partners-section>
        </template>

      </section>
    </div>
  </div>
</template>

<script>
import RelatedNews from "./RelatedNewsSection";
import ShopSection from "./ShopSection.vue";
import PartnersSection from "./PartnerSection.vue";
import RelatedLinkSection from "./RelatedLinkSection.vue";

import axios from 'axios';

import RestApiHelper from "../../../helpers/rest-api-func.js";
import { RestPageIdx, RestCustomPosts, WP_API_ACF_ROOT_URL, WP_API_WP_ROOT_URL } from '../../../helpers/rest-api-addr.js';


export default {
  data() {
    return {
      pageData : null,
      isLoadingSectionData : false
    }
  },
  mounted() {
    this.isLoadingSectionData = true;
    let self = this;
    this.$nextTick(function() {
      this.pageData = null;

      this.$nextTick(function() {
        RestApiHelper.requestPageData(WP_API_ACF_ROOT_URL, RestPageIdx.shared_content)
          .then(r_data => {
            self.setData(r_data.data, false);
          })
          .catch(error => {
            self.setData(null, false);
          });
        })
      })

  },
  props: {
    pageCommonData: {
      type : Object,
      default: function() {
        return null;
      }
    },
    isLoadingData: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setData(pageData, isLoading) {
      this.pageData = pageData;
      this.$nextTick(function() {
        this.isLoadingSectionData = isLoading;
      });
    }
  },
  components: {
    "app-related-news": RelatedNews,
    "app-shop-section": ShopSection,
    "app-partners-section": PartnersSection,
    "app-link-section": RelatedLinkSection
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/PageSharedSections.vue